import logoPng from "@/assets/logo.png";
import logoWebp from "@/assets/logo.webp";

export const Logo = ({ light = false }: { light?: boolean }) => (
  <div className="flex items-center gap-2">
    <picture>
      <source srcSet={logoWebp} type="image/webp" />
      <img
        src={logoPng}
        alt="Garage Kings YEG logo"
        width={40}
        height={40}
        decoding="async"
        className="h-10 w-10 rounded-xl object-cover"
      />
    </picture>
    <div className="leading-none">
      <div className={`font-display text-2xl tracking-wider ${light ? "text-white" : "text-ink"}`}>
        GARAGE <span className="text-gold">KINGS</span>
      </div>
      <div className={`text-[9px] uppercase tracking-[0.25em] ${light ? "text-white/60" : "text-muted-foreground"}`}>
        Edmonton, AB
      </div>
    </div>
  </div>
);
